import React from 'react';
import useDeviceType from '../../../hooks/useDeviceType';
import '../SectionBanner.scss';
import IntroBgWeb from '../../../assets/sectionBanners/Top_Banner_WEB.webp';
import IntroBgMob from '../../../assets/sectionBanners/Top_Banner_MOB.webp';
import IntroBgTab from '../../../assets/sectionBanners/Top_Banner_TABLET.webp';
import ImageBanner from '../../ImageBanner/ImageBanner';
import HighlightFirstMatch from '../../HighlightFirstMatch/HighlightFirstMatch';

const SectionBannerIntro = ({ baseClassName, t }) => {
    const { isMobileWidth } = useDeviceType();
    return (
        <ImageBanner
            image={IntroBgWeb}
            mobileImage={IntroBgMob}
            tabletImage={IntroBgTab}
        >
            <div
                className={`${baseClassName}__intro ${
                    isMobileWidth ? `${baseClassName}__intro-mobile` : ''
                }`}
            >
                <HighlightFirstMatch
                    text={t('Section.Banner.Intro.paragraph1')}
                    highlight={t('Section.Banner.Intro.title')}
                    spanClassName={`${baseClassName}__intro-highlight`}
                />
                <br />
                <div>{t('Section.Banner.Intro.paragraph2')}</div>
            </div>
        </ImageBanner>
    );
};

export default SectionBannerIntro;
